import { toast } from 'react-toastify';
import api from '../services/api';

/**
 * Documents live in a private S3 bucket, so their stored `url` is never directly accessible.
 * Always go through the backend, which hands back a short-lived signed URL.
 */

export async function viewDocument(documentId) {
  try {
    const res = await api.get(`/documents/${documentId}/access-url`);
    if (!res.data?.accessUrl) throw new Error('Could not get document link');
    window.open(res.data.accessUrl, '_blank', 'noopener,noreferrer');
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || 'Failed to open document');
  }
}

export async function downloadDocument(documentId) {
  try {
    // download=1 makes S3 serve the file as an attachment, so the browser saves it
    const res = await api.get(`/documents/${documentId}/access-url`, { params: { download: 1 } });
    if (!res.data?.accessUrl) throw new Error('Could not get document link');
    const a = document.createElement('a');
    a.href = res.data.accessUrl;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch (error) {
    toast.error(error.response?.data?.message || error.message || 'Failed to download document');
  }
}
